var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5921 4.85681C18.5236 3.8476 18.9894 3.343 19.4843 3.04866C20.6784 2.33845 22.1489 2.31636 23.3629 2.9904C23.8661 3.26975 24.3462 3.76015 25.3063 4.74095C26.2664 5.72175 26.7465 6.21215 27.0199 6.72616C27.6798 7.9664 27.6581 9.46849 26.9629 10.6884C26.6748 11.1939 26.1808 11.6697 25.1929 12.6213L13.4383 23.9429C11.5661 25.7461 10.63 26.6477 9.46008 27.1047C8.29015 27.5616 7.004 27.528 4.43171 27.4607L4.08172 27.4516C3.29863 27.4311 2.90709 27.4209 2.67948 27.1626C2.45188 26.9043 2.48295 26.5054 2.5451 25.7077L2.57885 25.2746C2.75376 23.0294 2.84122 21.9069 3.27963 20.8978C3.71805 19.8887 4.47429 19.0693 5.98678 17.4306L17.5921 4.85681Z",
    stroke: "#2177FE",
    strokeWidth: 2.30769,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5L25 13.75",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 27.5L27.5 27.5",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOrg);
export default __webpack_public_path__ + "static/media/EditOrg.a78560ca7e6ccf3b027c9239beb971ed.svg";
export { ForwardRef as ReactComponent };